/**
 * »Senest søgt« on the home page: the user's last searches, kept in this
 * browser only (per user, so a shared computer does not mix them up).
 */
const MAX = 6
const key = (userId: number) => `xosa-origin:recent-searches:${userId}`

export function readRecentSearches(userId: number): string[] {
  try {
    const raw = window.localStorage.getItem(key(userId))
    const parsed: unknown = raw ? JSON.parse(raw) : []
    return Array.isArray(parsed) ? parsed.filter((q): q is string => typeof q === 'string').slice(0, MAX) : []
  } catch {
    return []
  }
}

/** Puts the query first; the same query in other casing moves up instead of repeating. */
export function rememberSearch(userId: number, query: string): void {
  const q = query.trim().replace(/\s+/g, ' ')
  if (!q || q.length > 120) return
  const lower = q.toLocaleLowerCase('da')
  const next = [q, ...readRecentSearches(userId).filter((s) => s.toLocaleLowerCase('da') !== lower)].slice(0, MAX)
  try {
    window.localStorage.setItem(key(userId), JSON.stringify(next))
  } catch {
    // Storage blocked (private window): the list just stays empty.
  }
}

export function clearRecentSearches(userId: number): void {
  try {
    window.localStorage.removeItem(key(userId))
  } catch {
    // ignore
  }
}
